export enum Constants {
    RETURN_URL_KEY = 'tvApp.returnUrl',
    MEDIA = 'media', //maya api wants us to send media instead
    CAMPAIGN = 'campaign',
    CAMPAIGNANDMEDIA = 'campaignandmedia',
    CAMPAIGN_BUDGET_SIZE = 100000,
    BUDGET_LIMIT = 13,
    PAYMENT_STATUS_CHECK_INTERVAL = 10000,
    CAMAPIGN_BUDGET_MINIMUM = 3000
}
